import { switchAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'
import { mode } from '@chakra-ui/theme-tools'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(switchAnatomy.keys)

const baseStyleTrack = defineStyle(props => {
  const { colorScheme } = props

  return {
    borderColor: `${mode('blackAlpha.50', 'whiteAlpha.50')(props)} !important`,
    border: '1px solid',
    _hover: {
      borderColor: `${mode(
        'blackAlpha.100',
        'whiteAlpha.100'
      )(props)} !important`,
    },
    _checked: {
      bg: `${colorScheme}.500`,
      color: 'white',

      _hover: {
        bg: `${colorScheme}.600`,
      },
    },
  }
})

const baseStyle = definePartsStyle(props => ({
  track: baseStyleTrack(props),
}))

export const Switch = defineMultiStyleConfig({
  baseStyle,
  defaultProps: {
    colorScheme: 'brand',
  },
})
